import { useEffect, useState } from "react";
import {
    useHistory,
    useLocation,
} from "react-router-dom";
import { firestore, storage } from "./firebase";
import Sidebar from "./Sidebar";
import UpdateEvent from "./UpdateEvent";


export default function Updates() {
    const [events, setEvents] = useState([]);
    useEffect(() => {
        let query = firestore.collection('events');
        query = query.where('created_by', '==', 'event-form');
        query = query.orderBy('created_timestamp', 'desc').limit(100);
        query.onSnapshot(snapshot => setEvents(snapshot.docs.so));
    }, []);

    return <div className="h-full flex w-auto">
        <Sidebar defaultOpen={false} />
        <div className="flex-grow overflow-auto">
            <div className="h-screen flex flex-col overflow-hidden">
                <div className="bg-gray-600 flex items-center text-white gap-2 p-3 justify-between">
                    <div className="text-l font-semibold">Neue Events vom Formular</div>
                </div>
                <div className="p-3 overflow-y-scroll">
                    <div>
                        {events.map(event => <UpdateEvent key={event.id} object={event} />)}
                    </div>
                    {events.length === 0 && <div>
                        Es wurden keine neuen Events gefunden, die über das Formular erstellt wurden.
                    </div>}
                </div>
            </div>
        </div>
    </div>;
}